import Calendar from "./Calendar";
import ViewCode from "./DemoPage/viewCode";
import { useEffect, useState } from "react";
import { srcCode } from "./DemoPage/preCode";
import SideNav from "./DemoPage/sidenav";
import { addZero } from "./cldDisable";
import PropsFlow from "./DemoPage/propsFlow";
import cldIcon from "./Images/cldIcon.jpeg";
import MyResume from "./Images/Ranjith_Resume.pdf";
import ExternalLink from "./Images/link.svg";
import "./App.scss";

function App() { 
    const currentDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate()
    const [singleDate, setSingleDate] = useState({date: ""});
    const [multipleDate, setMultipleDate] = useState([]);
    const [rangeDate, setRangeDate] = useState({});
    const [singleSlot, setSingleSlot] = useState([])
    const [duelSlotDates, setDuelSlotDates] = useState([]);
    const [minandMaxDate, setMinandMaxDate] = useState<any>([]);
    const [rangeDateDisable, setRangeDateDisable] = useState<any>([]);
    const [dropDate, setDropDate] = useState(new Date());
    const [rangeDropDate, setRangeDropDate] = useState<any>({});
    const [singleDropOpen, setSingleDropOpen] = useState(true);
    const [rangeDropOpen, setRangeDropOpen] = useState(true);

    useEffect(() => {
      const month = new Date().getMonth();
      const year = new Date().getFullYear();
      const numArr = [2, 5, 8, 11, 17, 20, 23, 26];

      // multiple
      const multipleDateArr: any = [];
      for(let i=0; i <= numArr.length; i++){
        multipleDateArr.push(year + "-" + (month + 1) + "-" + numArr[i])
      }
      // single slot
      const singleSlotArr: any = [];
      for(let i=1; i <= 31; i++){
        singleSlotArr.push({ date: year + "-" + (month + 1) + "-" + i, avaliableSlot: Math.floor(Math.random() * 30) + 1 })
      }
      // duel slot
      const duelSlotDatesArr: any = [];
      for(let i=1; i <= 31; i++){
        duelSlotDatesArr.push({ date: year + "-" + (month + 1) + "-" + i, avaliableSlot: Math.floor(Math.random() * 30) + 1, totalSlot: "30" })
      }

      setSingleDate({date: year + "-" + (month + 1) + "-" + 18});
      setMultipleDate(multipleDateArr);
      setRangeDate({startDate: year + "-" + (month + 1) + "-" + 11, endDate: year + "-" + (month + 1) + "-" + 25 });
      setSingleSlot(singleSlotArr);
      setDuelSlotDates(duelSlotDatesArr);
      setMinandMaxDate([(year + "-" + (month + 3) + "-" + 10), (year + 1 + "-" + (month + 4) + "-" + 20)])
      setRangeDateDisable({startDate: year + "-" + (month + 1) + "-" + 12, endDate: year + "-" + (month + 1) + "-" + 25 });
      
    }, [])

    const startRangeDrop = rangeDropDate.startDate && addZero(rangeDropDate.startDate.getDate()) + "-" + addZero(rangeDropDate.startDate.getMonth()) + "-" + rangeDropDate.startDate.getFullYear() 
    const endRangeDrop = rangeDropDate.endDate ? rangeDropDate.endDate.getDate() + "-" + addZero(rangeDropDate.endDate.getMonth()) + "-" + rangeDropDate.endDate.getFullYear() : ""

  return (
    <div className="App">
      <nav className="topnav">
        <a href="https://github.com/ranjithvbr/react-select-date" rel="noreferrer" target="_blank">Github</a>
        <div>react-select-date</div>
        <a href={MyResume} target = "_blank" rel="noreferrer">About Me</a>
      </nav>
      <div className="demoContainer">
        <SideNav />
        <div className="content">
          <div className="startContent">
          <h3 id="getingStarted" className="gettingStartedHeader">Getting Started</h3>
          <p>
            This Calendar was developed using Hooks and Javascript date object without any dependencies. The calendar has options where users can choose between single-date, multiple-date, range and slots booking features.
          </p>
          <p>
          {`This package uses React hooks. Make sure you're running react >= 16.8.0 version.`}
          </p>
          <h4 className="installHeader">Installation</h4>
          <div className="installCon">
            <div># NPM <br /> npm i react-select-date</div>
          </div>
          <div className="installCon">
            <div># YARN <br /> yarn add react-select-date</div>
          </div>
          </div>
          <div className="demoCldContainer">
        <div>
        <h3 id="basicUsage" className="mainHeader">
            Basic Usage
          </h3>
          <h4 id="singleSelect" className="singleHeader">Example: Single Select</h4>
          <div className="cldInfo">The single-date selection is a fully controlled component that allows users to select a single date from the calendar table.</div>
          <div className="singleRangeCld">
            <Calendar 
              defaultValue={singleDate}
            />
          </div>
          <ViewCode preContent={srcCode('single', singleDate?.date)} />
        </div>
        <div>
          <h4 id="multiSelect" className="singleHeader">Example: Multi Select</h4>
          <div className="cldInfo">The multiple Date selection is a fully controlled component that allows users to select multiple dates.</div>
          <div className="singleRangeCld">
            <Calendar 
              selectDateType="multiple"
              defaultValue={multipleDate}
              templateClr="blue"
              showDateInputField={false}
            />
          </div>
          <ViewCode preContent={srcCode('multiple')} />
        </div>
        <div>
          <h4 id="rangeSelect" className="singleHeader">Example: Range Select</h4>
          <div className="cldInfo">The dateRange is a fully controlled component that allows users to select a date range. The user can select the date range from either the date-input field or the calendar table.</div>
          <div className="singleRangeCld">
            <Calendar 
              selectDateType="range"
              defaultValue={rangeDate}
            />
          </div>
          <ViewCode preContent={srcCode('range', rangeDate)} />
        </div>
        <div>
        <h3 id="slotBooking" className="mainHeader">
            Slot Booking
          </h3>
          <div className="slotInfo">Slots booking is a fully controlled component that allows users to view the avilable and total slots.</div>
          <h4 id="singleSlotBooking" className="singleHeader">Example: Single Slot</h4>
          <div className="slotSingleCldContainer">
            <Calendar 
              selectDateType="range"
              singleSlotDates={singleSlot}
              templateClr="blue"
            />
          </div>
          <ViewCode preContent={srcCode('singleSlot', singleSlot)} />
        </div>
        <div id="duelSlotBooking" className="duelCldConntainer">
          <h4 className="singleHeader">Example: Duel Slots</h4>
          <div className="slotDuelCldContainer">
            <Calendar 
              selectDateType="single"
              duelSlotDates={duelSlotDates}
              showSelectMonthArrow
              showSelectYearArrow
              showArrow={false}
              showDateInputField={false}
            />
          </div>
          <ViewCode preContent={srcCode('duelSlots', duelSlotDates)} />
        </div>
        <div>
        <h3 id="disableDates" className="mainHeader">
            Disable Dates
          </h3>
          <h4 id="minAndmax" className="singleHeader">Example: MinDate and MaxDate</h4>
          <div className="cldInfo">Defines the minimum and maximam date to show in the calender.</div>
          <div className="singleRangeCld">
            <Calendar 
              minDate={minandMaxDate[0]}
              maxDate={minandMaxDate[1]}
              selectDateType="multiple"
            />
          </div>
          <ViewCode preContent={srcCode('minAndmax', minandMaxDate)} />
        </div>
        <div>
          <h4 id="disableSpecific" className="singleHeader">Example: Disable Specific Dates and Disable Days</h4>
          <div className="cldInfo">Defines the disable specific dates and disable days to show in the calender.</div>
          <div className="singleRangeCld">
            <Calendar 
              selectDateType="range"
              defaultValue={rangeDateDisable}
              disableDays={["sun", "sat"]} 
              disableCertainDates={multipleDate}
            />
          </div>
          <ViewCode preContent={srcCode('specific', rangeDateDisable, multipleDate)} />
        </div>
        <div>
        <h3 id="customization" className="mainHeader">
            Customization
          </h3>
          <h4 id="dropDown" className="singleHeader">Example: Dropdown</h4>
          <div className="cldInfo">Can customize the calender like Date Fields</div>
          <div className="dropDown-flex">
          <div className="dropDownCld">
            <div className="dropdownContainer">
                <div className="inputRelative">
                  <div className="imgRelative" onClick={(()=>setSingleDropOpen(!singleDropOpen))}>
                    <input readOnly value={addZero(dropDate?.getDate()) + "-" + addZero(dropDate?.getMonth()) + "-" + dropDate?.getFullYear()}  className="cldInput" />
                    <img src={cldIcon} alt="calendar" className="imgAbsolute"/>
                  </div>
                  {singleDropOpen && <div className="cldAbsolute">
                  <Calendar 
                  defaultValue={{date: currentDate}}
                  showDateInputField={false}
                  slotInfo={false}
                  onSelect={(date: any)=>setDropDate(date)}
                />
              </div>}
              </div>
            </div>
          </div>
          <div className="dropDownCld">
            <div className="dropdownContainer">
                <div className="inputRelative">
                  <div className="imgRangeRelative" onClick={(()=>setRangeDropOpen(!rangeDropOpen))}>
                    <input readOnly value={
                      startRangeDrop + "  < -- >  " + endRangeDrop
                      } className="cldRangeInput" />
                    <img src={cldIcon} alt="calendar" className="imgRangeAbsolute"/>
                  </div>
                {rangeDropOpen && <div className="cldAbsolute">
                  <Calendar 
                  defaultValue={rangeDateDisable}
                  showDateInputField={false}
                  slotInfo={false}
                  templateClr="blue"
                  selectDateType={"range"}
                  onSelect={(date: any)=>setRangeDropDate(date)}
                />
              </div>}
              </div>
            </div>
            </div>
            </div>
          <a href="https://codesandbox.io/s/react-select-date-customcalendar-tlvsw?file=/src/App.js" target="_blank" rel="noreferrer" className="viewCode_container linkSize">
                  <div className="viewCodebtn"><img src={ExternalLink} alt="externalLink" />CodeSandbox</div>
            </a>
        </div>
        <div>
          <h4 id="overrideCss" className="singleHeader">Example: Override CSS</h4>
          <div className="singleRangeCld overridecss">
            <Calendar 
              selectDateType="range"
              defaultValue={rangeDateDisable}
              disableDays={["sun", "sat"]} 
              slotInfo={false}
              showDatelabel
            />
          </div>
          <ViewCode preContent={srcCode('css')} fixedHeight />
        </div>
          <PropsFlow />
        </div>
        </div>
        </div>
    </div>
  );
}

export default App;
